import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "login-or-request-access" };
const _hoisted_2 = { key: 0 };
import { ref } from "vue";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginOrRequestAccess',
    setup(__props) {
        const accessRequestsEnabled = ref(config.accessRequestsEnabled);
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                (accessRequestsEnabled.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _createVNode(_component_router_link, {
                            to: { name: 'login_access' },
                            class: "button button--outline button--small"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_icon, { name: "user-lock" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.request-access')), 1)
                            ]),
                            _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('or')), 1)
                    ]))
                    : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createVNode(_component_router_link, {
                    to: { name: 'login' },
                    class: "button button--outline button--small"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_icon, { name: "login" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('login.log-in')), 1)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
